export default __webpack_public_path__ + "static/media/Notion.256734ae.svg";